export default __webpack_public_path__ + "static/media/communicative.5a335351.webp";